import React, { useState, useEffect } from "react";
import HODProfile from "./HODProfile";
import SNOProfile from "./SNOProfile";
const LineDepartmentProfile = () => {
  const [type, setType] = useState("HOD");
  const user_id = sessionStorage.getItem("user_id");
  const token = sessionStorage.getItem("token");
  const [sachivDetails, setSachivDetails] = useState([]);
  const switchButton = (type) => {
    if (type == "HOD") {
      setType("HOD");
    }
    if (type == "SNO") {
      setType("SNO");
    }
  };
  return (
    <>
      <div
        className="container-fluid"
        style={{ background: "#fff", overflowX: "hidden" }}
      >
        <div className="d-flex justify-content-center align-items-center gap-4 pt-2">
          <div className="d-flex">
            <button
              className={
                type === "HOD"
                  ? "btn btn-outline-primary"
                  : "btn btn-outline-secondary"
              }
              onClick={(e) => switchButton("HOD")}
              style={{
                backgroundColor: type === "HOD" ? "#4763E4" : "#4763E430",
                color: type === "HOD" ? "#fff" : "#4763E4",
                border: "none",
                padding: "10px 20px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#4763E4";
                e.target.style.color = "#fff";
              }}
              onMouseOut={(e) => {
                if (type !== "HOD") {
                  e.target.style.backgroundColor = "#4763E430";
                  e.target.style.color = "#4763E4";
                }
              }}
            >
              Head of Department
            </button>
          </div>
          <button
            className={
              type === "SNO"
                ? "btn btn-outline-primary"
                : "btn btn-outline-secondary"
            }
            onClick={(e) => switchButton("SNO")}
            style={{
              backgroundColor: type === "SNO" ? "#4763E4" : "#4763E430",
              color: type === "SNO" ? "#fff" : "#4763E4",
              border: "none",
              padding: "10px 20px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#4763E4";
              e.target.style.color = "#fff";
            }}
            onMouseOut={(e) => {
              if (type !== "SNO") {
                e.target.style.backgroundColor = "#4763E430";
                e.target.style.color = "#4763E4";
              }
            }}
          >
            State Nodal Officer
          </button>
        </div>
        {type == "HOD" ? (
          <HODProfile />
        ) : type == "SNO" ? (
          <SNOProfile />
        ) : null}
      </div>
    </>
  );
};
export default LineDepartmentProfile;
